/**
 * Operations that get their own Apollo HTTP batch group (keyed by operation name) instead of
 * sharing the app-wide foreground/background batch. Without this, a slow query batched together
 * with fast ones (e.g. the new-ui dashboard firing ~9 queries at once) delays every response in
 * that batch until the slowest one resolves, since they all ride on a single HTTP request.
 */
export const excludeFromBatching = [
  "getNewUiDashboardOpenTasksMetric",
  "getNewUiDashboardCandidateEventsMetric",
  "getNewUiDashboardCandidateBirthdays",
  "getNewUiDashboardAnkaadiaUpdate",
  "getNewUiDashboardCandidateStates",
  "getNewUiDashboardCandidateStatesAtDate",
  "getNewUiDashboardSharedCollections",
  "getNewUiDashboardTalentPoolRequests",
  "getNewUiDashboardTalentPoolSharings",
];
